import React from "react";
import { Button } from "react-bootstrap";
import { styleBlock } from "../styleBlock";
/**
 * VariantPicker renders a group of color buttons for selecting a variant string.
 */
const VariantPicker = ({ value, onChange, variantLabels, className, style }) => {
    const block = styleBlock("variantPicker");
    const wrapperClass = block("wrapper").mix(className).toString();
    return (React.createElement("div", { className: wrapperClass, style: style }, ["info", "warning", "danger"].map(variant => (React.createElement(Button, { variant: "dark", key: variant, className: block("btn", { [variant]: true, selected: value === variant }).toString(), onClick: () => onChange(variant), active: value === variant }, variantLabels[variant] || variant)))));
};
export default VariantPicker;
//# sourceMappingURL=index.js.map